import React from 'react';
import { SVGIconProps } from '../../domains/common';

const AppsFlyerIcon: React.FC<SVGIconProps> = ({ colored, ...rest }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="1 1 35 37"
      width="2em"
      height="2em"
      fill="#220D4E"
      {...rest}
    >
      <path
        d="M0.2,12.7L6.3,24c0.4,0.8,1.5,1.4,2.3,1.4H21c0.8,0,1.2-0.6,0.8-1.4l-6.2-11.3c-0.4-0.8-1.5-1.4-2.3-1.4H0.9H0.8 C0.1,11.3-0.2,11.9,0.2,12.7z"
        fill={colored ? '#7DC242' : '#3F5B8D'}
      />
      <path
        d="M23.8,25.8l3.7,6.7c0.2,0.5,0.8,0.8,1.4,0.8l7.4-0.1c0.5,0,0.7-0.4,0.5-0.8l-3.7-6.7c-0.2-0.5-0.8-0.8-1.4-0.8 l-7.4,0.1C23.8,25,23.5,25.4,23.8,25.8z"
        fill={colored ? '#7DC242' : '#3F5B8D'}
      />
      <path
        d="M23.8,0.4l-7.4,9.2c-0.5,0.6-0.5,1.8-0.1,2.5l6.2,11.2c0.4,0.8,1.1,0.9,1.7,0.2l7.4-9.2 c0.5-0.6,0.5-1.8,0.1-2.5L25.5,0.7c-0.2-0.4-0.6-0.7-1-0.7C24.3,0,24.1,0.1,23.8,0.4z"
        fill={colored ? '#00B9F1' : '#3F5B8D'}
      />
      <path
        d="M22.1,25.9l-4.4,5.5c-0.3,0.4-0.4,1-0.1,1.5l3.7,6.7c0.2,0.5,0.7,0.5,1,0.1l4.4-5.5c0.3-0.4,0.4-1,0.1-1.5 L23.2,26c-0.1-0.2-0.4-0.4-0.5-0.4C22.4,25.7,22.3,25.7,22.1,25.9z"
        fill={colored ? '#00B9F1' : '#3F5B8D'}
      />
    </svg>
  );
};

export default AppsFlyerIcon;
